import request from './request';

// 帮助中心-首页栏目列表
export function getModelData() {
    return request('/help-center/models', {
        method: 'GET',
    });
}

// 进入某一栏目，获取左边列表
export function toColumn(id) {
    return request(`/help-center/models/${id}`, {
        method: 'GET',
    });
}

// 查询文章详情
export function toArticlesDetail(id, params) {
    return request(`/help-center/articles/${id}`, {
        method: 'GET',
        params,
    });
}

// 帮组中心首页/搜索页 搜索接口
export function searchContent(params) {
    return request('/help-center/articles', {
        method: 'GET',
        params,
    });
}
